
          import { defineNuxtPlugin } from "#imports";

          export default defineNuxtPlugin({
            name: 'sentry-client-config',
            async setup() {
              await import("/home/forge/career.proxify.io/releases/20261105110027/sentry.client.config.js")
            }
          });